import React, { Component } from "react";
import { toast } from "react-toastify";
import "./ventaEditarModal.css";
import { actualizarVentas } from "../../../service/api";
import SpinnerModal from "../../spiner/SpinnerModal";

export default class VentaEditarModal extends Component {
  constructor(props) {
    super(props);

    const item = props.data || {};

    this.state = {
      idticketpago: item.idticketpago || "",
      ticket: item.idticket || "",
      locacion: item.locacion || "",
      metodo_pago: item.metodo_pago || "",
      fecha: item.fecha || "",
      estatus: item.estatus || "",
      idestatus: this.getEstatusIdActual(item),

      ajustes: item.ajustes || "",
      detalles: item.detalles,
      ultimos_digitos: this.safeText(item.ultimos_digitos),
      transaccion: this.safeText(item.transaccion),
      total: this.formatInputMoney(item.total),
      propina: this.formatInputMoney(item.propina),

      tipo_cambio: this.formatInputMoney(item.tipo_cambio ?? item.tc),
      total_cobrado: this.formatInputMoney(item.total_cobrado),
      moneda_cobro: this.safeText(item.moneda_cobro),

      originalData: {
        ajustes: item.ajustes || "",
        detalles: item.detalles || "",
        ultimos_digitos: this.safeText(item.ultimos_digitos),
        transaccion: this.safeText(item.transaccion),
        total: this.formatInputMoney(item.total),
        propina: this.formatInputMoney(item.propina),
        tipo_cambio: this.formatInputMoney(item.tipo_cambio ?? item.tc),
        total_cobrado: this.formatInputMoney(item.total_cobrado),
        moneda_cobro: this.safeText(item.moneda_cobro),
        estatus: item.estatus || "",
        idestatus: this.getEstatusIdActual(item),
      },

      hasChanges: false,
      loading: false,
      savedRow: item,
      shouldRefreshParentOnClose: false,
    };
  }

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const dataChanged = prevProps.data !== this.props.data;

    if (openedNow || dataChanged) {
      const item = this.props.data || {};

      this.setState({
        idticketpago: item.idticketpago || "",
        ticket: item.idticket || "",
        locacion: item.locacion || "",
        metodo_pago: item.metodo_pago || "",
        fecha: item.fecha || "",
        estatus: item.estatus || "",
        idestatus: this.getEstatusIdActual(item),

        ajustes: item.ajustes, // no usar safeText
        detalles: item.detalles, // no usar safeText
        ultimos_digitos: this.safeText(item.ultimos_digitos),
        transaccion: this.safeText(item.transaccion),
        total: this.formatInputMoney(item.total),
        propina: this.formatInputMoney(item.propina),

        tipo_cambio: this.formatInputMoney(item.tipo_cambio ?? item.tc),
        total_cobrado: this.formatInputMoney(item.total_cobrado),
        moneda_cobro: this.safeText(item.moneda_cobro),

        originalData: {
          ajustes: item.ajustes, // no usar safeText
          detalles: item.detalles, // no usar safeText
          estatus: item.estatus || "",
          idestatus: this.getEstatusIdActual(item),
          ultimos_digitos: this.safeText(item.ultimos_digitos),
          transaccion: this.safeText(item.transaccion),
          total: this.formatInputMoney(item.total),
          propina: this.formatInputMoney(item.propina),
          tipo_cambio: this.formatInputMoney(item.tipo_cambio ?? item.tc),
          total_cobrado: this.formatInputMoney(item.total_cobrado),
          moneda_cobro: this.safeText(item.moneda_cobro),
        },

        hasChanges: false,
        savedRow: item,
        shouldRefreshParentOnClose: false,
      });
    }
  }

  safeText = (value) => {
    if (value == null) return "";
    if (String(value).toLowerCase() === "null") return "";
    return String(value).trim();
  };

  parseNumber = (value) => {
    if (value == null || value === "") return 0;

    let clean = String(value).trim();
    clean = clean.replace(/\$/g, "").replace(/\s/g, "");

    if (clean.includes(",") && !clean.includes(".")) {
      clean = clean.replace(",", ".");
    } else if (clean.includes(",") && clean.includes(".")) {
      clean = clean.replace(/,/g, "");
    }

    const n = Number(clean);
    return Number.isNaN(n) ? 0 : n;
  };

  roundMoney = (value) => {
    const n = Number(value || 0);
    return Math.round((n + Number.EPSILON) * 100) / 100;
  };

  formatMoney = (value) => {
    return this.roundMoney(value).toFixed(2);
  };

  formatInputMoney = (value) => {
    if (value == null || value === "") return "";
    return this.formatMoney(this.parseNumber(value));
  };

  formatMoneyView = (value) => {
    if (value == null || value === "") return "—";
    return `$ ${this.formatMoney(this.parseNumber(value))}`;
  };

  normalizeText = (value) => this.safeText(value);

  isMoneyField = (field) => {
    return ["total", "propina", "tipo_cambio", "total_cobrado"].includes(field);
  };

  computeHasChanges = (nextState) => {
    const original = nextState.originalData || this.state.originalData || {};

    const currentComparable = {
      ajustes: this.normalizeText(nextState.ajustes),
      detalles: this.normalizeText(nextState.detalles),
      ultimos_digitos: this.normalizeText(nextState.ultimos_digitos),
      transaccion: this.normalizeText(nextState.transaccion),
      total: this.formatMoney(this.parseNumber(nextState.total)),
      propina: this.formatMoney(this.parseNumber(nextState.propina)),
      tipo_cambio: this.formatMoney(this.parseNumber(nextState.tipo_cambio)),
      total_cobrado: this.formatMoney(this.parseNumber(nextState.total_cobrado)),
      moneda_cobro: this.normalizeText(nextState.moneda_cobro),
      idestatus: this.normalizeText(nextState.idestatus),

    };

    const originalComparable = {
      ajustes: this.normalizeText(original.ajustes),
      detalles: this.normalizeText(original.detalles),
      ultimos_digitos: this.normalizeText(original.ultimos_digitos),
      transaccion: this.normalizeText(original.transaccion),
      total: this.formatMoney(this.parseNumber(original.total)),
      propina: this.formatMoney(this.parseNumber(original.propina)),
      tipo_cambio: this.formatMoney(this.parseNumber(original.tipo_cambio)),
      total_cobrado: this.formatMoney(this.parseNumber(original.total_cobrado)),
      moneda_cobro: this.normalizeText(original.moneda_cobro),
      idestatus: this.normalizeText(original.idestatus),
    };

    return JSON.stringify(currentComparable) !== JSON.stringify(originalComparable);
  };

  onFieldChange = (field, value) => {
    this.setState((prev) => {
      const nextState = {
        ...prev,
        [field]: value,
      };

      return {
        [field]: value,
        hasChanges: this.computeHasChanges(nextState),
      };
    });
  };

  onMoneyChange = (field, value) => {
    const clean = String(value || "")
      .replace(",", ".")
      .replace(/[^0-9.]/g, "");

    const parts = clean.split(".");
    const normalized =
      parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : clean;

    this.onFieldChange(field, normalized);
  };

  onMoneyBlur = (field) => {
    this.setState((prev) => {
      const currentValue = prev[field];

      if (currentValue === "") {
        const nextState = {
          ...prev,
          [field]: "",
        };

        return {
          [field]: "",
          hasChanges: this.computeHasChanges(nextState),
        };
      }

      const normalized = this.formatMoney(this.parseNumber(currentValue));
      const nextState = {
        ...prev,
        [field]: normalized,
      };

      return {
        [field]: normalized,
        hasChanges: this.computeHasChanges(nextState),
      };
    });
  };

  hasInvalidSpecialChars = (value) => /[<>[\]{}|^~`]/.test(String(value || ""));
  isOnlyDigits = (value) => /^\d+$/.test(String(value || "").trim());
  isAlphaNumericBasic = (value) => /^[A-Za-z0-9\s#:_-]+$/.test(String(value || "").trim());
  isCurrencyCodeBasic = (value) => /^[A-Za-z]{3,10}$/.test(String(value || "").trim());




  canEditEstatusPago = () => {
    const item = this.state.savedRow || this.props.data || {};
    return Number(item.facturableexterno || 0) === 1;
  };

  getEstatusIdActual = (item = {}) => {
    const id = item.idestatus || item.id_estatus || item.idestatus_pago;

    if (id) return String(id);

    const estatus = this.safeText(item.estatus).toLowerCase();

    if (estatus === "facturado") return "3";
    if (estatus === "pendiente") return "4";

    return "";
  };
  validateBeforeSave = () => {
    const {
      idticketpago,
      ultimos_digitos,
      transaccion,
      total,
      propina,
      tipo_cambio,
      total_cobrado,
      moneda_cobro,
    } = this.state;

    if (!Number(idticketpago || 0)) {
      toast.info("No se encontró el idticketpago.");
      return false;
    }

    if (!this.state.hasChanges) {
      return false;
    }



    if (ultimos_digitos) {
      if (!this.isOnlyDigits(ultimos_digitos)) {
        toast.info("Los últimos dígitos deben contener solo números.");
        return false;
      }

      if (String(ultimos_digitos).trim().length !== 4) {
        toast.info("Los últimos dígitos deben tener exactamente 4 números.");
        return false;
      }
    }

    if (transaccion && !this.isAlphaNumericBasic(transaccion)) {
      toast.info("La transacción contiene caracteres no permitidos.");
      return false;
    }

    if (total !== "" && this.parseNumber(total) < 0) {
      toast.info("El total no puede ser menor a 0.");
      return false;
    }

    if (propina !== "" && this.parseNumber(propina) < 0) {
      toast.info("La propina no puede ser menor a 0.");
      return false;
    }

    if (tipo_cambio !== "" && this.parseNumber(tipo_cambio) < 0) {
      toast.info("El tipo de cambio no puede ser menor a 0.");
      return false;
    }

    if (total_cobrado !== "" && this.parseNumber(total_cobrado) < 0) {
      toast.info("El total cobrado no puede ser menor a 0.");
      return false;
    }

    if (moneda_cobro && !this.isCurrencyCodeBasic(moneda_cobro)) {
      toast.info("La moneda de cobro debe contener solo letras.");
      return false;
    }

    return true;
  };

  getPayload = () => {
    const { originalData } = this.state;
    const payload = {};

    const currentDetalles = this.normalizeText(this.state.detalles);
    const originalDetalles = this.normalizeText(originalData.detalles);

    const currentAjustes = this.normalizeText(this.state.ajustes);
    const originalAjustes = this.normalizeText(originalData.ajustes);


    const currentUltimos = this.normalizeText(this.state.ultimos_digitos);
    const originalUltimos = this.normalizeText(originalData.ultimos_digitos);

    const currentTransaccion = this.normalizeText(this.state.transaccion);
    const originalTransaccion = this.normalizeText(originalData.transaccion);

    const currentTotal = this.state.total === "" ? "" : this.roundMoney(this.parseNumber(this.state.total));
    const originalTotal = originalData.total === "" ? "" : this.roundMoney(this.parseNumber(originalData.total));

    const currentPropina = this.state.propina === "" ? "" : this.roundMoney(this.parseNumber(this.state.propina));
    const originalPropina = originalData.propina === "" ? "" : this.roundMoney(this.parseNumber(originalData.propina));

    const currentTipoCambio =
      this.state.tipo_cambio === "" ? "" : this.roundMoney(this.parseNumber(this.state.tipo_cambio));
    const originalTipoCambio =
      originalData.tipo_cambio === "" ? "" : this.roundMoney(this.parseNumber(originalData.tipo_cambio));

    const currentTotalCobrado =
      this.state.total_cobrado === "" ? "" : this.roundMoney(this.parseNumber(this.state.total_cobrado));
    const originalTotalCobrado =
      originalData.total_cobrado === "" ? "" : this.roundMoney(this.parseNumber(originalData.total_cobrado));

    const currentMonedaCobro = this.normalizeText(this.state.moneda_cobro).toUpperCase();
    const originalMonedaCobro = this.normalizeText(originalData.moneda_cobro).toUpperCase();
    const currentIdEstatus = this.normalizeText(this.state.idestatus);
    const originalIdEstatus = this.normalizeText(originalData.idestatus);

    if (this.canEditEstatusPago() && currentIdEstatus !== originalIdEstatus) {
      payload.idestatus = Number(currentIdEstatus);
    }

    if (currentDetalles !== originalDetalles) payload.detalles = currentDetalles;
    if (currentAjustes !== originalAjustes) payload.ajustes = currentAjustes;
    if (currentUltimos !== originalUltimos) payload.ultimos_digitos = currentUltimos;
    if (currentTransaccion !== originalTransaccion) payload.transaccion = currentTransaccion;
    if (currentTotal !== originalTotal) payload.total = currentTotal;
    if (currentPropina !== originalPropina) payload.propina = currentPropina;
    if (currentTipoCambio !== originalTipoCambio) payload.tipo_cambio = currentTipoCambio;
    if (currentTotalCobrado !== originalTotalCobrado) payload.total_cobrado = currentTotalCobrado;
    if (currentMonedaCobro !== originalMonedaCobro) payload.moneda_cobro = currentMonedaCobro;

    return payload;
  };

  mergeSavedRow = (serverData = {}) => {
    const prevRow = this.state.savedRow || this.props.data || {};
  
    const idestatusFinal =
      serverData.idestatus ?? serverData.id_estatus ?? this.state.idestatus;
  
    let estatusFinal = serverData.estatus ?? prevRow.estatus ?? this.state.estatus;
  
    if (this.canEditEstatusPago()) {
      estatusFinal = String(idestatusFinal) === "3" ? "Facturado" : "Pendiente";
    }
  
    return {
      ...prevRow,
      ...serverData,
  
      facturableexterno:
        serverData.facturableexterno ?? prevRow.facturableexterno ?? 0,
  
      idestatus: idestatusFinal,
      estatus: estatusFinal,
  
      detalles: serverData.detalles ?? this.state.detalles,
      ajustes: serverData.ajustes ?? this.state.ajustes,
      ultimos_digitos: serverData.ultimos_digitos ?? this.state.ultimos_digitos,
      transaccion: serverData.transaccion ?? this.state.transaccion,
      total: serverData.total ?? this.formatMoney(this.parseNumber(this.state.total || 0)),
      propina: serverData.propina ?? this.formatMoney(this.parseNumber(this.state.propina || 0)),
      tipo_cambio: serverData.tipo_cambio ?? this.state.tipo_cambio,
      tc: serverData.tc ?? this.state.tipo_cambio,
      total_cobrado: serverData.total_cobrado ?? this.state.total_cobrado,
      moneda_cobro: serverData.moneda_cobro ?? this.state.moneda_cobro,
    };
  };

  onGuardar = async () => {
    try {
      if (!this.validateBeforeSave()) return;

      const idticketpago = Number(this.state.idticketpago || 0);
      const payload = this.getPayload();

      if (Object.keys(payload).length === 0) {
        this.setState({ hasChanges: false });
        return;
      }

      this.setState({ loading: true });

      const resp = await actualizarVentas(idticketpago, payload);

      if (resp?.code === 0) {
        const mergedRow = this.mergeSavedRow(resp?.data || {});



        this.setState({
          estatus: mergedRow.estatus,
          idestatus: this.getEstatusIdActual(mergedRow),
          detalles: mergedRow.detalles,
          ajustes: mergedRow.ajustes,
          ultimos_digitos: this.safeText(mergedRow.ultimos_digitos),
          transaccion: this.safeText(mergedRow.transaccion),
          total: this.formatInputMoney(mergedRow.total),
          propina: this.formatInputMoney(mergedRow.propina),
          tipo_cambio: this.formatInputMoney(mergedRow.tipo_cambio ?? mergedRow.tc),
          total_cobrado: this.formatInputMoney(mergedRow.total_cobrado),
          moneda_cobro: this.safeText(mergedRow.moneda_cobro),


          originalData: {
            estatus: mergedRow.estatus,
            idestatus: this.getEstatusIdActual(mergedRow),

            detalles: mergedRow.detalles,
            ajustes: mergedRow.ajustes,
            ultimos_digitos: this.safeText(mergedRow.ultimos_digitos),
            transaccion: this.safeText(mergedRow.transaccion),
            total: this.formatInputMoney(mergedRow.total),
            propina: this.formatInputMoney(mergedRow.propina),
            tipo_cambio: this.formatInputMoney(mergedRow.tipo_cambio ?? mergedRow.tc),
            total_cobrado: this.formatInputMoney(mergedRow.total_cobrado),
            moneda_cobro: this.safeText(mergedRow.moneda_cobro),

          },

          hasChanges: false,
          loading: false,
          savedRow: mergedRow,
        });

        toast.success(resp?.message || "Venta actualizada correctamente.");

        if (this.props.onSavedLocal) {
          await this.props.onSavedLocal(mergedRow);
        }

        return;
      }

      this.setState({ loading: false });
      toast.info(resp?.message || "No fue posible guardar los cambios.");
    } catch (e) {
      this.setState({ loading: false });
      toast.info("Ocurrió un error al guardar la venta.");
    }
  };

  formatDateShort = (value) => {
    if (!value) return "—";

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";

    const meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    const dd = String(d.getDate()).padStart(2, "0");
    const mmm = meses[d.getMonth()];
    const yyyy = d.getFullYear();

    return `${dd}-${mmm}-${yyyy}`;
  };

  handleClose = () => {
    const rowToReturn = this.state.savedRow || this.props.data || null;

    if (this.props.onClose) {
      this.props.onClose({
        updatedRow: rowToReturn,
      });
    }
  };

  renderReadField = (label, value, extraClass = "", isMoney = false) => (
    <div className={`ve-field ${extraClass}`}>
      <label>{label}</label>
      <div className="ve-value">
        {isMoney ? this.formatMoneyView(value) : (this.safeText(value) || "—")}
      </div>
    </div>
  );

  renderInputField = ({
    label,
    value,
    onChange,
    onBlur,
    placeholder = "",
    type = "text",
    extraClass = "",
    maxLength,
    money = false,
  }) => (
    <div className={`ve-field ${extraClass}`}>
      <label>{label}</label>
      <div className={`ve-inputWrap ${money ? "ve-inputWrapMoney" : ""}`}>
        {money ? <span className="ve-prefix">$</span> : null}
        <input
          type={type}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={this.state.loading}
        />
      </div>
    </div>
  );

  renderTextAreaField = ({
    label,
    value,
    onChange,
    placeholder = "",
    extraClass = "",
    maxLength,
    disabled = false,
  }) => (
    <div className={`ve-field ${extraClass}`}>
      <label>{label}</label>
      <textarea
        className="ve-textarea"
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled || this.state.loading}
      />
    </div>
  );

  render() {
    const { show } = this.props;
    const loading = this.props.loading || this.state.loading;
    if (!show) return null;



    return (

      <>
        {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

        <div className="ve-backdrop">

          <div className="ve-modal">
            <div className="ve-head">
              <div className="ve-headText">
                <div className="ve-title">Editar venta</div>
              </div>

              <button type="button" className="ve-close" onClick={this.handleClose}>
                ×
              </button>
            </div>

            {loading ? (
              <div className="ve-loading">Cargando...</div>
            ) : (
              <>
                <div className="ve-body">
                  <div className="ve-card">
                    <div className="ve-cardHead">
                      <div>
                        <div className="ve-cardTitle">Información del pago</div>
                      </div>

            
                    </div>

                    <div className="ve-grid">
                      {this.renderReadField("Número de ticket", this.state.ticket)}
                      {this.renderReadField("Locación", this.state.locacion)}

                      {/* {this.renderReadField("Método de pago", this.state.metodo_pago)}
                      this.renderReadField("Estatus", this.state.estatus)*/}

{this.renderReadField("Método de pago", this.state.metodo_pago)}

{!this.canEditEstatusPago()
  ? this.renderReadField("Estatus", this.state.estatus)
  : (
    <div className="ve-field ve-statusEdit">
      <label>Estatus</label>
      <select
        value={this.state.idestatus || ""}
        onChange={(e) => {
          const value = e.target.value;

          this.setState((prev) => {
            const nextState = {
              ...prev,
              idestatus: value,
              estatus: value === "3" ? "Facturado" : "Pendiente",
            };

            return {
              idestatus: value,
              estatus: value === "3" ? "Facturado" : "Pendiente",
              hasChanges: this.computeHasChanges(nextState),
            };
          });
        }}
        disabled={this.state.loading}
      >
        <option value="4">Pendiente</option>
        <option value="3">Facturado</option>
      </select>
    </div>
  )
}




                      {this.renderReadField(
                        "Fecha",
                        this.formatDateShort(this.state.fecha)
                      )}
                      {this.renderInputField({
                        label: "Últimos dígitos",
                        value: this.state.ultimos_digitos,
                        onChange: (e) =>
                          this.onFieldChange(
                            "ultimos_digitos",
                            e.target.value.replace(/\D/g, "").slice(0, 4)
                          ),
                        placeholder: "1234",
                        maxLength: 4,
                      })}

                      {this.renderInputField({
                        label: "Transacción",
                        value: this.state.transaccion,
                        onChange: (e) => this.onFieldChange("transaccion", e.target.value),
                        placeholder: "ABC123",
                        maxLength: 60,
                      })}

                      {this.renderInputField({
                        label: "Total",
                        value: this.state.total,
                        onChange: (e) => this.onMoneyChange("total", e.target.value),
                        onBlur: () => this.onMoneyBlur("total"),
                        placeholder: "0.00",
                        money: true,
                      })}

                      {this.renderInputField({
                        label: "Propina",
                        value: this.state.propina,
                        onChange: (e) => this.onMoneyChange("propina", e.target.value),
                        onBlur: () => this.onMoneyBlur("propina"),
                        placeholder: "0.00",
                        money: true,
                      })}

                      {this.renderInputField({
                        label: "T. C.",
                        value: this.state.tipo_cambio,
                        onChange: (e) => this.onMoneyChange("tipo_cambio", e.target.value),
                        onBlur: () => this.onMoneyBlur("tipo_cambio"),
                        placeholder: "0.00",
                        money: true,
                      })}

                      {this.renderInputField({
                        label: "Cobrado",
                        value: this.state.total_cobrado,
                        onChange: (e) => this.onMoneyChange("total_cobrado", e.target.value),
                        onBlur: () => this.onMoneyBlur("total_cobrado"),
                        placeholder: "0.00",
                        money: true,
                      })}

                      {this.renderInputField({
                        label: "Moneda cobro",
                        value: this.state.moneda_cobro,
                        onChange: (e) =>
                          this.onFieldChange(
                            "moneda_cobro",
                            e.target.value.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 10)
                          ),
                        placeholder: "MXN",
                        maxLength: 10,
                      })}

                      {this.renderTextAreaField({
                        label: "Detalles",
                        value: this.state.detalles,
                        onChange: (e) => this.onFieldChange("detalles", e.target.value),
                        placeholder: "Last Digits: 5696 Transaction#: 863502",
                        extraClass: "ve-span-2",
                        maxLength: 250,
                      })}

                      {this.renderTextAreaField({
                        label: "Ajustes",
                        value: this.state.ajustes,
                        onChange: (e) => this.onFieldChange("ajustes", e.target.value),
                        placeholder: "...",
                        extraClass: "ve-span-2",
                        maxLength: 250,
                      })}




                    </div>
                  </div>
                </div>

                <div className="ve-foot">
                  <button
                    type="button"
                    className="ve-btn ve-btnGhost"
                    onClick={this.handleClose}
                    disabled={this.state.loading}
                  >
                    Cerrar
                  </button>
                  <button
                    type="button"
                    className="ve-btn ve-btnPrimary"
                    onClick={this.onGuardar}
                    disabled={this.state.loading || !this.state.hasChanges}
                  >
                    {this.state.loading ? "Guardando..." : "Guardar"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}